jQuery( document ).ready(function($) {
    if($('.productchoice_abo_en_cours').length > 0) {
        $('.checkout_final_page').css('display', 'none');
    }
    $( "#place_order" ).click(function() {
        $('.loader_box').css('display', 'flex');
    });
  });